import { gql } from "@apollo/client";

/** Deliberately slim documents for the BYOC dashboard. */

/**
 * Count of active external cards on one linked account.
 *
 * `first` is omitted on purpose. The `cards` resolver sets `pageInfo.total` to
 * the length of the current page, so a paged request would report the page size
 * rather than the count; with no limit the resolver accumulates everything and
 * the edge count is the real total. `CardConnection.pageInfo` has no `total`
 * field at all, so the count comes from `edges` either way.
 *
 * A separate document from `GET_CARDS` rather than an extra variable on it:
 * that query declares neither `$cardType` nor `$status`, so Apollo silently
 * drops both and `LinkedAccounts` is today counting cards of every type and
 * status. Fixing it there is a real behaviour change and does not belong in
 * the same breath as a dashboard count.
 */
export const GET_ACCOUNT_CARD_COUNT = gql`
  query byocAccountCardCount(
    $accountId: ID
    $cardType: [CardType]
    $cardStatus: [CardStatus]
  ) {
    cards(accountId: $accountId, cardType: $cardType, cardStatus: $cardStatus) {
      edges {
        node {
          id
        }
      }
    }
  }
`;

/**
 * Aggregates for one compliance type across the whole company.
 * See the `complianceMetrics` field in server/graphql/types/Transaction.graphql.
 */
export const GET_COMPLIANCE_METRICS = gql`
  query complianceMetrics($compliance: TransactionCompliance!) {
    complianceMetrics(compliance: $compliance) {
      count
      totalAmount
      oldestTransactionDate
      currency
      byUser {
        userId
        firstName
        lastName
        count
        totalAmount
      }
    }
  }
`;
